module.exports = __webpack_public_path__ + "img/oursolution8.cc19d2f7.png";